import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ThreeBackground from "../../components/common/ThreeBackground";
import Icon from "../../components/common/Icon";
import "./NotFound.css";
import { useSeo, SEO } from "../../config/seo";

const ease = [0.21, 0.8, 0.25, 1];

const LINKS = [
  { to: "/home", label: "Home" },
  { to: "/service", label: "Solutions" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contactus", label: "Contact" },
];

export default function NotFound() {
  useSeo(SEO.notFound);
  return (
    <main className="cv-home cv-404">
      <ThreeBackground variant="constellation" />
      <motion.div
        className="cv-404__inner"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease }}
      >
        <span className="cv-eyebrow"><span className="dot" /> 404</span>
        <h1 className="cv-404__title">
          This page isn&rsquo;t <span className="cv-gradient-text">part of the system</span>.
        </h1>
        <p className="cv-404__sub">
          The link is broken or the page has moved. Here&rsquo;s where everything else lives.
        </p>

        <nav className="cv-404__links">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="cv-chip cv-404__link">
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/contactus" className="cv-btn cv-404__cta">
          Bring us your challenge <Icon name="arrow" size={18} className="arrow" />
        </Link>
      </motion.div>
    </main>
  );
}
